__turbopack_context__.v({
  "card": "Tariffs-module-scss-module__L8eknG__card",
  "fishes": "Tariffs-module-scss-module__L8eknG__fishes",
  "mobileTitle": "Tariffs-module-scss-module__L8eknG__mobileTitle",
  "section": "Tariffs-module-scss-module__L8eknG__section",
});
